import script from "./FixtureCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FixtureCard.vue?vue&type=script&setup=true&lang=js"

import "./FixtureCard.vue?vue&type=style&index=0&id=a6d4b90c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6d4b90c"]])

export default __exports__